import { render, staticRenderFns } from "./AttributeVenta.vue?vue&type=template&id=085cc147"
import script from "./AttributeVenta.vue?vue&type=script&lang=js"
export * from "./AttributeVenta.vue?vue&type=script&lang=js"
import style0 from "./AttributeVenta.vue?vue&type=style&index=0&id=085cc147&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports